// Single registry of every cascade in the engagement review.
//
// To add a new cascade: add an entry to the appropriate category file
// (or create a new one and import it here). No other file needs to change.

import { capitalAssetCascades } from "./capitalAssets";
import { equityCascades } from "./equity";
import { workingCapitalCascades } from "./workingCapital";
import { debtTaxCascades } from "./debtTax";
import { incomeAndIntangibleCascades } from "./incomeAndIntangible";
import { transactionCascades } from "./transactions";

export const CASCADE_REGISTRY = {
	...capitalAssetCascades,
	...equityCascades,
	...workingCapitalCascades,
	...debtTaxCascades,
	...incomeAndIntangibleCascades,
	...transactionCascades,
};
